import { Lightbox } from '@mews/business-components';
import { carouselFactory, CarouselStyledMewsImage } from '@mews/gx-ui';
import { connect } from './connect';

export const CategoryCarousel = connect(
    carouselFactory({
        Lightbox,
        CarouselImage: CarouselStyledMewsImage,
    })
);
